(() => {
  const MOBILE_BREAKPOINT = 749;

  function initCollectionNavigation(scope = document) {
    const sidebars = scope.querySelectorAll(
      '[data-collection-navigation]:not([data-collection-navigation-ready])'
    );

    sidebars.forEach((sidebar) => {
      const toggle = sidebar.querySelector('[data-collection-nav-toggle]');
      const content = sidebar.querySelector('[data-collection-nav-content]');

      if (!toggle || !content) return;

      sidebar.setAttribute('data-collection-navigation-ready', '');

      const setState = (isOpen) => {
        sidebar.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
      };

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        setState(!isOpen);
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
          setState(false);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCollectionNavigation();
    });
  } else {
    initCollectionNavigation();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionNavigation(event.target);
  });
})();